<template>
    <modal :show.sync=show modalClasses="large-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Detail Variable Expenses</h3>
        <div class="table-simple-modal">
            <b-table-simple responsive bordered>
                <b-thead>
                    <b-tr>
                        <b-th class="custome-width">Variable Expenses Items</b-th>
                        <b-th>Before (RM) (<span class="text-red">Month</span>)</b-th>
                        <b-th>After (RM) (<span class="text-red">Month</span>)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in detailVarExpenses" :key="index">
                        <b-td class="text-capitalize custom-width">{{ item.label }}</b-td>
                        <b-td>{{ item.amount_before | moneyFormatter }}</b-td>
                        <b-td>{{ item.amount_after | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>
                <b-tfoot>
                    <b-tr class="font-weight-600">
                        <b-td>Total</b-td>
                        <b-td>{{ total.amount_before | moneyFormatter }}</b-td>
                        <b-td>{{ total.amount_after | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tfoot>
            </b-table-simple>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import _ from 'lodash'
export default {
    props:{
				show_total_variable_expenses: Boolean,
        detailVarExpenses: Array,
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.show_total_variable_expenses;
            },
            set(newVal) {
                this.$emit('update:show_total_variable_expenses', newVal);
            },
        },
				total(){
					return {
						amount_before: _.sumBy(this.detailVarExpenses,(o)=>{return o.amount_before}),
						amount_after: _.sumBy(this.detailVarExpenses,(o)=>{return o.amount_after})
					}	
				}
    }
}
</script>